import { FC } from 'react'
import style from './Hello.module.css'

const Hello: FC = () => {
	return <section className={style.container}>THIS IS WELCOME SECTION</section>
}

export default Hello
